///<reference path="../../../../../vendor/misqtech/totalsuite-totalcore/assets/scripts/common/decorators.ts" />
///<reference path="../../../../../vendor/misqtech/totalsuite-totalcore/assets/scripts/common/models/model.ts" />
namespace TotalPoll {
    import Model = TotalCore.Common.Models.Model;

    export class Entry extends Model {
        getDate() {
            return this.get('date');
        }

        getField(fieldName) {
            let value = this.get(`fields.${fieldName}`, this.get(fieldName));

            if (angular.isArray(value)) {
                value = value.join(', ');
            }

            return value;
        }

        getFields() {
            return this.get('fields', {});
        }
    }
}